<app-home-widget id="widget">
    @if (showLoadingIndicator) {
        <app-loading-indicator [delay]="300" backgroundColor="transparent" />
    } @else {
        @if (isUserView) {
            <app-admin-users />
        } @else if (isFaqView) {
            <app-admin-faq />
        } @else if (isResponsibleView) {
            <app-admin-responsible />
        } @else if (isHyperlinkView) {
            <app-admin-hyperlink />
        } @else if (isGlossaryView) {
            <app-admin-glossary />
        } @else if (isReportView) {
            <app-admin-report />
        } @else if (isReportTemplateView) {
            <app-admin-report-template />
        }
    }
</app-home-widget>
